<template>
  <div>
    <!-- 退款数量编辑 -->
    <el-dialog :title="$t('message.editRefundQuantity')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="480px" center>
      <div class="content">
        <!-- 待退款数量 -->
        <div class="row">
          <div class="label">
            {{ $t("message.pendingRefundQuantity") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="new_num" onfocus="this.select()" @input="handleInput"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 提交修改 -->
        <el-button type="primary" @click="save">
          {{ $t("message.submitModification") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    checkList: { type: Array }
  },
  data() {
    return {
      new_num: '',
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: [],
        new_num: this.new_num,
      };
      this.checkList.forEach(item => {
        datas.ids.push(item.id)
      })
      if (!this.new_num) return this.$message.error('请输入待退款数量')
      this.$api.inSaleApi.updateNewNum(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.inSaleList()
      });
    },
    // 是否输入的小数
    handleInput(value) {
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.new_num = this.new_num.replaceAll('.', '');
        this.new_num = this.new_num.replaceAll('-', '');
        this.new_num = this.new_num.replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

}
</style>